module.exports = __webpack_public_path__ + "img/workout1.53906179.jpg";